import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { SharedModule } from '../shared/shared.module';
import { AuthRoutingModule } from './auth.routing.module';

import { AuthFormPageComponent } from './containers/auth-form-page/auth-form-page.component';
import { AuthFormComponent } from './components/auth-form/auth-form.component';

import { AuthSignupFormPageComponent } from './containers/auth-signup-form-page/auth-signup-form-page.component';
import { AuthSsoFormPageComponent } from './containers/auth-sso-form-page/auth-sso-form-page.component';
import { AuthSignupFormComponent } from './components/auth-signup-form/auth-signup-form.component';
import { AuthSsoFormComponent } from './components/auth-sso-form/auth-sso-form.component';

import { AuthService } from './services/auth.service';
import { AuthInterceptor } from './services/auth.interceptor';
import { AuthGuard } from './guards/auth.guard';
import { FeatureFlagGuard } from './guards/feature-flag.guard';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    AuthRoutingModule
  ],
  declarations: [
    AuthFormPageComponent,
    AuthSignupFormPageComponent,
    AuthFormComponent,
    AuthSsoFormPageComponent,
    AuthSignupFormComponent,
    AuthSsoFormComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    AuthService,
    AuthGuard,
    FeatureFlagGuard,
  ]
})
export class AuthModule { }
